// test1049
(1049 && 0);
